const EventEmitter = require('event-emitter-es6');

export default class Checkbox extends EventEmitter {
    constructor(el) {
        super();
        this.el = el;
        this.active = false;
        this.id = el.dataset.id;

        this.bindEvents();
    }

    bindEvents() {
        this.el.addEventListener('click', event => this.clickHandler(event));
    }

    clickHandler(event) {
        this.toggleCheckbox();
    }

    toggleCheckbox() {
        this.active = !this.active;
        this.el.classList.toggle('isActive');
        this.emit('changed', this.active);
    }

    setActive() {
        this.active = true;
        this.el.classList.add('isActive');
    }

    setInactive() {
        this.active = false;
        this.el.classList.remove('isActive');
    }

    getStatus() {
        return this.active;
    }
}



// WEBPACK FOOTER //
// ./src/components/checkbox/checkbox.js